import { j as i, c as p } from "../../utils-BdNIfrGQ.js";
import * as c from "react";
import { c as k } from "../../index-UQQE3dtT.js";
import { P as m } from "../../index-oiSd2zY3.js";
import { c as I } from "../../index-Di82Y7n3.js";
import { n as R } from "../../normalize-spacing-DY0KSpr_.js";
var u = "Progress", v = 100, [V] = k(u), [j, E] = V(u), f = c.forwardRef(
  (r, a) => {
    const {
      __scopeProgress: o,
      value: e = null,
      max: s,
      getValueLabel: w = _,
      ...y
    } = r;
    (s || s === 0) && !d(s) && console.error(M(`${s}`, "Progress"));
    const t = d(s) ? s : v;
    e !== null && !g(e, t) && console.error(A(`${e}`, "Progress"));
    const l = g(e, t) ? e : null, $ = n(l) ? w(l, t) : void 0;
    return /* @__PURE__ */ i.jsx(j, { scope: o, value: l, max: t, children: /* @__PURE__ */ i.jsx(
      m.div,
      {
        "aria-valuemax": t,
        "aria-valuemin": 0,
        "aria-valuenow": n(l) ? l : void 0,
        "aria-valuetext": $,
        role: "progressbar",
        "data-state": h(l, t),
        "data-value": l ?? void 0,
        "data-max": t,
        ...y,
        ref: a
      }
    ) });
  }
);
f.displayName = u;
var b = "ProgressIndicator", x = c.forwardRef(
  (r, a) => {
    const { __scopeProgress: o, ...e } = r, s = E(b, o);
    return /* @__PURE__ */ i.jsx(
      m.div,
      {
        "data-state": h(s.value, s.max),
        "data-value": s.value ?? void 0,
        "data-max": s.max,
        ...e,
        ref: a
      }
    );
  }
);
x.displayName = b;
function _(r, a) {
  return `${Math.round(r / a * 100)}%`;
}
function h(r, a) {
  return r == null ? "indeterminate" : r === a ? "complete" : "loading";
}
function n(r) {
  return typeof r == "number";
}
function d(r) {
  return n(r) && !isNaN(r) && r > 0;
}
function g(r, a) {
  return n(r) && !isNaN(r) && r <= a && r >= 0;
}
function M(r, a) {
  return `Invalid prop \`max\` of value \`${r}\` supplied to \`${a}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${v}\`.`;
}
function A(r, a) {
  return `Invalid prop \`value\` of value \`${r}\` supplied to \`${a}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${v} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var N = f, S = x;
const P = c.forwardRef(({ className: r, value: a, ...o }, e) => /* @__PURE__ */ i.jsx(
  N,
  {
    ref: e,
    className: p("relative w-full overflow-hidden", r),
    ...o,
    children: /* @__PURE__ */ i.jsx(
      S,
      {
        className: "h-full w-full flex-1 transition-all",
        style: { transform: `translateX(-${100 - (a || 0)}%)` }
      }
    )
  }
));
P.displayName = N.displayName;
const z = {
  default: "h-5",
  thin: "h-4"
}, C = I("shadow rounded-lg", {
  variants: {
    color: {
      primary: "bg-[hsl(var(--progress-bar-track,var(--primary-light)/0.4))] text-primary-dark",
      success: "bg-[hsl(var(--progress-bar-track,var(--success-light)/0.4))] text-success-dark",
      warning: "bg-[hsl(var(--progress-bar-track,var(--warning-light)/0.4))] text-warning-dark",
      info: "bg-[hsl(var(--progress-bar-track,var(--info-light)/0.4))] text-info-dark",
      destructive: "bg-[hsl(var(--progress-bar-track,var(--destructive-light)/0.4))] text-destructive-dark"
    },
    size: z
  },
  defaultVariants: {
    color: "success",
    size: "default"
  },
  compoundVariants: [
    {
      color: "primary",
      className: "*:bg-[hsl(var(--progress-bar-fill,var(--primary)))]"
    },
    {
      color: "success",
      className: "*:bg-[hsl(var(--progress-bar-fill,var(--success)))]"
    },
    {
      color: "info",
      className: "*:bg-[hsl(var(--progress-bar-fill,var(--info)))]"
    },
    {
      color: "warning",
      className: "*:bg-[hsl(var(--progress-bar-fill,var(--warning)))]"
    },
    {
      color: "destructive",
      className: "*:bg-[hsl(var(--progress-bar-fill,var(--destructive)))]"
    }
  ]
}), D = ({
  color: r = "success",
  size: a = "default",
  value: o,
  spacing: e
}) => /* @__PURE__ */ i.jsx(
  P,
  {
    value: o,
    className: p(C({ color: r, size: a }), R(e))
  }
);
D.displayName = "Progress bar";
export {
  D as default
};
